AppTabs.createTab( {
name: 'quote-defaults',
icon: 'th-list',
text: 'Quote Defaults',
create: function() {
    'use strict'

    return new TabControllerVue({
        el: '#vue-quote-defaults',
        data: {
			manager:      null,
			managerTitle: null,
			paragraph1:   null,
			paragraph2:   null,
			terms: null
        },
        methods: {
			onShowTab() {
				const _this = this;
				window.ajaxCall({
					data : {
						action: 'get_quote_defaults',
					},
					successMessage: 'Successfully Retrieved Quote Defaults',
					onSuccess: _this.setFromData,
				});
			},
			setFromData( { data } ) {
				this.manager      = data.manager;
				this.managerTitle = data.managerTitle;
				this.paragraph1   = data.paragraph1;
				this.paragraph2   = data.paragraph2;
				this.terms = data.terms;
			},
			updateManager() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_quote_defaults',
						quote_defaults_data: { manager : _this.manager },
					},
					successMessage: 'Successfully Updated Default Quote Manager',
					onSuccess: _this.setFromData,
				});
			},
			updateManagerTitle() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_quote_defaults',
						quote_defaults_data: { managerTitle : _this.managerTitle },
					},
					successMessage: 'Successfully Updated Default Quote Manager Title',
					onSuccess: _this.setFromData,
				});
			},
			updateParagraph1() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_quote_defaults',
						quote_defaults_data: { paragraph1 : _this.paragraph1 },
					},
					successMessage: 'Successfully Updated Default Quote Paragraph 1',
					onSuccess: _this.setFromData,
				});
			},
			updateParagraph2() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_quote_defaults',
						quote_defaults_data: { paragraph2 : _this.paragraph2 },
					},
					successMessage: 'Successfully Updated Default Quote Paragraph 2',
					onSuccess: _this.setFromData,
				});
			},
			updateTerms() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_quote_defaults',
						quote_defaults_data: { terms : _this.terms },
					},
					successMessage: 'Successfully Updated Default Quote Terms',
					onSuccess: _this.setFromData,
				});
			},
        },
    });

}

} );
